import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const Modal = ({ open, onClose, style, header, body, footer, size, disableBackdropClick = false, disableEscapeKeyDown = false }) => {

  return (
    <div>
       <Dialog 
         open={open} 
         onClose={onClose} 
         disableEscapeKeyDown={disableEscapeKeyDown}
         maxWidth={size}
         fullWidth 
         style={style}
         scroll="paper"
         PaperProps={{
           sx: {
             maxHeight: '90vh', // Limit modal height to 90% of viewport height
             display: 'flex',
             flexDirection: 'column',
             m: 1, // Add margin to prevent full-bleed on small screens
             width: 'calc(100% - 16px)', // Account for margin
             overflowX: 'hidden' // Prevent horizontal scrolling
           }
         }}
       >
        {header && (
          <DialogTitle sx={{ fontSize: '16px', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>{header}</DialogTitle>
        )}
        {body && (
          <DialogContent 
            sx={{ 
              overflow: 'auto', 
              flex: '1 1 auto', // Allow content to grow but also shrink if needed
              p: 2,
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(0,0,0,0.05)',
                borderRadius: '8px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0,0,0,0.2)',
                borderRadius: '8px',
              }
            }}
          >
            <DialogContentText sx={{ color: 'inherit' }}>
              {body}
            </DialogContentText>
          </DialogContent>
        )}
        {footer && (
          <DialogActions sx={{ p: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
            {footer}
          </DialogActions>
        )}
      </Dialog> 
    </div>
  );
};

export default Modal;
